import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const ContentStudio = lazy(() => import("../pages/content-studio"));
const ContentStudioListing = lazy(() =>
  import("../pages/content-studio-listing")
);
const ContentStudioJourney = lazy(() =>
  import("../pages/content-studio-journey")
);
const ContentStudioDetails = lazy(() =>
  import("../pages/content-studio-details")
);
const CreateContentStudio = lazy(() =>
  import("../pages/create-content-studio-new")
);

export const ContentStudioRouter = [
  {
    path: "/content-studio",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "/content-studio/dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ContentStudio />
          </Suspense>
        ),
      },
      {
        path: "/content-studio/listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ContentStudioListing />
          </Suspense>
        ),
      },
      {
        path: "/content-studio/journey",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ContentStudioJourney />
          </Suspense>
        ),
      },
      {
        path: "/content-studio/:details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ContentStudioDetails />
          </Suspense>
        ),
      },
      {
        path: "/content-studio/create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateContentStudio key="create" />
          </Suspense>
        ),
      },
      {
        path: "/content-studio/create/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateContentStudio key="create-edit" />
          </Suspense>
        ),
      },
      {
        path: "/content-studio/edit/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateContentStudio key="create" />
          </Suspense>
        ),
      },
    ],
  },
];
